module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2b2499f31323d7bd8e360c764a838cc6.gif";